import { Stack } from '@mui/material'
import type { FC } from 'react'

import { CarouselLoading, unit } from '@hcr/ui'

import { BookingOverviewHomeLoading } from '../common/booking-overview/booking-overview-home'

import { LayoutHome } from './common'
import { HeaderHomeLoading } from './common/header-home'

export const HomeLoading: FC = () => {
  return (
    <LayoutHome
      content={<CarouselLoading slidesMargin={unit(3)} />}
      header={
        <Stack gap={unit(4)}>
          <BookingOverviewHomeLoading />
          <HeaderHomeLoading />
        </Stack>
      }
      imageUrl={''}
    />
  )
}
